import { NoteIcon, ZapIcon } from "@primer/octicons-react";
import * as React from "react";
import { Link } from "react-router-dom";
import Spinner from "../../Spinner";
import { Text } from "../../models";
import { crop, numerize } from "../../utils";
import DownloadSplitButton from "./DownloadSplitButton";

const TextCard: React.FC<{ text: Text; onStart: () => void; url: string }> = ({
  text: t,
  onStart,
  url,
}) => {
  return (
    <div className="text-item">
      <div className="overview">{crop(t.body)}</div>
      {t.status === "done" && (
        <div className="chat-length">
          <Link to={url}>
            <NoteIcon size={16} />
            {numerize(t.items_count, "card", "cards")} ready — edit
          </Link>
        </div>
      )}
      {t.status !== "done" && (
        <div className="chat-length">
          {numerize(t.body.length, "character", "characters")}
        </div>
      )}
      <div className="status">
        {t._error && <>{t._error}</>}
        {!t._error && t.status === "pending" && (
          <div className="button-wrapper">
            <button onClick={() => onStart()}>
              <ZapIcon size={16} />
              GENERATE CARDS
            </button>
          </div>
        )}
        {!t._error && t.status === "enqueued" && <>Enqueued...</>}
        {!t._error && t.status === "running" && (
          <>
            <Spinner /> Running...
          </>
        )}
        {!t._error && t.status === "errored" && (
          <div className="error">
            <div>Error</div>
            <button onClick={() => onStart()}>TRY AGAIN</button>
          </div>
        )}
        {!t._error && t.status === "done" && (
          <div className="button-wrapper">
            <DownloadSplitButton uid={t.uid} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TextCard;
